/** 
  * @class Resource Class for HTML Content
  * @extends SSResource
  * @param {Object} config An options hash with settings for the Resource
  */
import SSResource from './00-slideshare_resource';

function SSHtmlResource(config){
  this.resourceTemplate = {
    prefix: config.baseUrl,
    key : 'page_',
    suffix: '.js?' + config.timestamp,
    digitLength: 4,
    cacheable: true,
    retries : 2,
    isCritical: true
  };
  if(config.is_private && config.signature === undefined){
    this.loadBlocked = true;
  }
  SSResource.call(this, config);
}

SSHtmlResource.prototype = new SSResource();




SSHtmlResource.prototype.ready = function(){
  this._initResourceConfig();
  this.loadBlocked = false;
  if (this.status === 'loading'){
    this.load();
  }
};

/** 
  * Configures the resource based on the resourceType
  */
SSHtmlResource.prototype._initResourceConfig = function(){
  if(this.config.is_private && this.config.signature === undefined) {
    return;
  }
  var resourceTemplate = this.resourceTemplate;
  var indexString = this.config.indexGenerator(this.config.realIndex, resourceTemplate.digitLength);

  if(this.config.is_private){
    this.url = resourceTemplate.prefix +
                resourceTemplate.key + indexString + '.js' + this.config.signature;
  }
  else{
    this.url = resourceTemplate.prefix + resourceTemplate.key + indexString + resourceTemplate.suffix;
  }
  this.cacheable = resourceTemplate.cacheable;
  this.retries = resourceTemplate.retries || 0;
  this.isCritical = resourceTemplate.isCritical;
};

/** 
  * Appends signature to the url of the resource for a private pres
  */
SSHtmlResource.prototype.updateSignature = function(signature){
 this.config.signature = signature;
};

/**
  * @private
  * Tries to load the resource
  */
SSHtmlResource.prototype._tryLoad = function(){
  $.jsonp({
    url: this.url,
    callback : 'slideshare_jsonp_hook_trigger',
    success : this.resourceLoadedInternalHandler(),
    error : this.resourceErrorInternalHandler(),
    cache : true,
    timeout : 10000
  });
};


/**
  * EventHandler factory for when resource finishes loading successfully
  * @private
  */
SSHtmlResource.prototype.resourceLoadedInternalHandler = function(){

  var that = this;
  return function(data){
    // manipulating styles from the conversion resources
    //   stripping out duplicate styles, removing font-faces
    var replacedStyle = data.style.replace(/a\.ssml_a \{.*?\}/,'')
      .replace(/\.ssml_div span \{.*?\}/,'')
      .replace(/\.ps([\s\S]*?)\{[\s\S]*?\}/g,'')
      .replace(/@font-face[\s\S]*?\{[\s\S]*?\}/g,'');

    that.html = data.html;
    that.style = replacedStyle;
    
    $.slideshareEventManager.trigger('resourceloaded', {
      index : that.config.slideIndex,
      resourceKey : that.resourceKey      
    });
  };
};

/**
  * Returns the resource content for use by the Slide
  */
SSHtmlResource.prototype.getContent = function(){
  return {
    html : this.html,
    style : this.style
  };
};

export default SSHtmlResource;
